module.exports = __webpack_public_path__ + "static/media/formul14.85335830.png";